import * as React from "react";
import { FilterBar } from "azure-devops-ui/FilterBar";
import { Observer } from "azure-devops-ui/Observer";
import { KeywordFilterBarItem } from "azure-devops-ui/TextFilterBarItem";
import { Filter, FILTER_CHANGE_EVENT, FilterOperatorType } from "azure-devops-ui/Utilities/Filter";
import {
    DropdownSelection,
    DropdownMultiSelection
} from "azure-devops-ui/Utilities/DropdownSelection";
import { DropdownFilterBarItem } from "azure-devops-ui/Dropdown";
import { singleListItems, multiListItems } from "./Data";
import { ObservableValue } from "azure-devops-ui/Core/Observable";

export default class FilterBarExample extends React.Component {
    private filter: Filter;
    private currentState = new ObservableValue("");
    private selectionSingleList = new DropdownSelection();
    private selectionMultiList = new DropdownMultiSelection();
    private selectionEmptyList = new DropdownMultiSelection();

    constructor(props: {}) {
        super(props);

        this.filter = new Filter();
        this.filter.setFilterItemState("listMulti", {
            value: [],
            operator: FilterOperatorType.and
        });
        this.filter.subscribe(() => {
            this.currentState.value = JSON.stringify(this.filter.getState(), null, 4);
        }, FILTER_CHANGE_EVENT);
    }

    public render() {
        return (
            <div className="flex-grow">
                <FilterBar filter={this.filter}>
                    <KeywordFilterBarItem filterItemKey="Placeholder" />

                    <DropdownFilterBarItem
                        filterItemKey="listSingle"
                        filter={this.filter}
                        items={singleListItems.map(i => {
                            return {
                                id: i,
                                text: i,
                                iconProps: { iconName: "Home" }
                            };
                        })}
                        selection={this.selectionSingleList}
                        placeholder="Status"
                    />

                    <DropdownFilterBarItem
                        filterItemKey="listMulti"
                        filter={this.filter}
                        items={multiListItems.map(i => {
                            return {
                                id: i,
                                text: i,
                                iconProps: {
                                    render: () => (
                                        <img
                                            className="custom-button-icon"
                                            src={require("./persona-female.png")}
                                        />
                                    )
                                }
                            };
                        })}
                        selection={this.selectionMultiList}
                        placeholder="Author"
                    />

                    <DropdownFilterBarItem
                        filterItemKey="listMultiEmpty"
                        filter={this.filter}
                        items={[]}
                        selection={this.selectionEmptyList}
                        placeholder="Empty"
                        noItemsText="No items found"
                    />
                </FilterBar>
                <div style={{ marginTop: "16px" }} className="monospaced-text">
                    <span>Current state:</span>
                    <Observer currentState={this.currentState}>
                        {(props: { currentState: string }) => (
                            <span>{this.currentState.value}</span>
                        )}
                    </Observer>
                </div>
            </div>
        );
    }
}
